import React, { useRef, useEffect } from 'react'
import { Dialog } from 'primereact/dialog'
import ChatInput from './ChatInput'
import '../../styles/chatbot.scss'
import { ChatMessages } from './ChatMessages'

interface ChatDialogProps {
	visible: boolean
	onHide: () => void
	fullScreen?: boolean
	header?: React.ReactNode
}

export const ChatDialog: React.FC<ChatDialogProps> = ({
	visible,
	onHide,
	fullScreen = false,
	header,
}) => {
	const messagesContainerRef = useRef<HTMLDivElement>(null)
	const scrollPositionRef = useRef<number>(0)

	// Salva la posizione dello scroll prima della transizione
	useEffect(() => {
		if (messagesContainerRef.current) {
			scrollPositionRef.current = messagesContainerRef.current.scrollTop
		}
	}, [fullScreen])

	// Ripristina la posizione dello scroll dopo la transizione
	useEffect(() => {
		if (messagesContainerRef.current && scrollPositionRef.current > 0) {
			messagesContainerRef.current.scrollTop = scrollPositionRef.current
		}
	}, [fullScreen])

	return (
		<Dialog
			visible={visible}
			onHide={onHide}
			className={`chat-dialog ${
				fullScreen ? 'chat-dialog-fullscreen' : ''
			}`}
			header={header}
			footer={<ChatInput />}
			modal={false}
			draggable={!fullScreen}
			resizable={!fullScreen}
			position={fullScreen ? undefined : 'bottom-right'}
			closeOnEscape={false}
			closable={false}
			style={{
				width: fullScreen ? '100vw' : '400px',
				height: fullScreen ? '100vh' : '600px',
			}}>
			<div className="chat-window">
				<ChatMessages />
			</div>
		</Dialog>
	)
}
